// src/utils/exportCsv.js
export function exportCsv(tasks = [], filename) {
  const safe = (v) => {
    if (v == null) return "";
    const s = String(v);
    // quote if it has comma, quote, or newline
    return /[,"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const headers = [
    "id","clientName","driver","pickupAddress","dropoffAddress",
    "status","deliverBy","pieces","weight","price","total",
    "base","miles","deadheadMiles","waitMinutes","holdoverNights","dedicatedHours","afterHours",
    "mileageCharge","deadheadCharge","weightCharge","waitCharge","holdoverCharge","afterHoursCharge","dedicatedCharge","fuelSurcharge",
    "createdAt"
  ];

  const rows = tasks.map(t => {
    const c = t.charges || {};
    return [
      t.id ?? t.number ?? "",
      t.clientName ?? "",
      t.driver ?? "",
      t.pickupAddress ?? "",
      t.dropoffAddress ?? "",
      t.status ?? "",
      t.deliverBy ?? "",
      t.pieces ?? "",
      t.weight ?? "",
      t.price ?? "",
      t.total ?? "",
      t.base ?? "",
      t.miles ?? "",
      t.deadheadMiles ?? "",
      t.waitMinutes ?? "",
      t.holdoverNights ?? "",
      t.dedicatedHours ?? "",
      t.afterHours ? "yes" : "no",
      c.mileageCharge ?? "",
      c.deadheadCharge ?? "",
      c.weightCharge ?? "",
      c.waitCharge ?? "",
      c.holdoverCharge ?? "",
      c.afterHoursCharge ?? "",
      c.dedicatedCharge ?? "",
      c.fuelSurcharge ?? "",
      t.createdAt ?? ""
    ].map(safe).join(",");
  });

  const csv = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });

  const ts = new Date().toISOString().slice(0,19).replace(/[:T]/g,"-");
  const name = filename || `tasks_${ts}.csv`;

  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name; // triggers Save As / download
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}

